import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import { ThemeProvider } from '@mui/material/styles';
import CustomTheme from '../../../styles/theme';
import './custom-text-field.scss';
import DniTooltip from '../dni-tooltip/dni-tooltip';
const CustomTextField = (customTextFieldProps) => {
    const { showDniTooltip, onClickDniTooltip, error, errorMessages, errorMessage, ...props } = customTextFieldProps;
    return (_jsx(ThemeProvider, { theme: CustomTheme, children: _jsx(TextField, { className: `custom-text-field ${props.disabled ? 'disabled-input' : ''}`, variant: "outlined", autoComplete: 'off', ...props, InputLabelProps: {
                sx: {
                    color: '#434A54',
                    '&.Mui-focused': {
                        marginTop: '10px',
                        color: '#656D78'
                    },
                    '&.MuiFormLabel-filled': {
                        marginTop: '10px',
                        color: '#656D78'
                    }
                },
            }, InputProps: {
                sx: {
                    color: '#434A54',
                    marginTop: '0px',
                    '& input::placeholder': {
                        marginTop: '0px',
                        color: 'transparent'
                    },
                    borderRadius: '12px',
                    '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
                        display: 'none'
                    },
                    '& input[type=number]': {
                        MozAppearance: 'textfield'
                    },
                },
                className: props.disabled ? 'disabled-text-color' : '',
                endAdornment: showDniTooltip &&
                    _jsxs(Box, { className: 'dni-tooltip', onClick: onClickDniTooltip, children: [_jsx(DniTooltip, { className: 'dni-tooltip_desktop' }), _jsx(DniTooltip, { className: 'dni-tooltip_mobile' })] })
            }, error: error, helperText: error ? (_jsx("div", { children: errorMessages ? errorMessages.map((errorMessage, index) => (_jsx("div", { children: errorMessage }, index))) : errorMessage })) : null }) }));
};
export default CustomTextField;
